import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { AdsPOSTApiWithToken, UserPlaceHolder } from '../../Constant/api';
import { slugs } from '../../Constant/slugs';
import store from '../../redux/store';
import axios from 'axios';
import ColorVision from '../Student/ ColorVisionSt';
import SecondScreenComponent from '../Student/ExamDetails/GetStartedPage';
import FinalScreenExam from '../Student/ExamDetails/MarksObtainedPage';
var nodejsurl = "https://real-exam.epsexam.com/base64"

export default function FirstScreenExam(props) {
  const {
    ExamData,
    setReload,
    choose, setChoose,
    AnswerArray, setAnswerArray,
    ResultData, setResultData,
  } = props;
  const LoginUser = useSelector((state) => state.LoginState);
  const history = useHistory();
  const location = useLocation();
  const [QuestionsData, setQuestionsData] = React.useState(JSON.parse(ExamData.meta.exam_question_block_text))
  const [QuestionsEditMode, setQuestionsEditMode] = React.useState(true);
  const [QuestionsEditData, setQuestionsEditData] = React.useState(JSON.parse(ExamData.meta.exam_question_block_text)["item-0"])
  const [PlaySingle, setPlaySingle] = React.useState(ExamData.meta.media_non_repeat);
  const [QuestionsEditKey, setQuestionsEditKey] = React.useState("item-0");
  const [TimingStarted, setTimingStarted] = React.useState(false);
  const [userDetails, setUserDetails] = React.useState({})
  const [obtainedMarks, setObtainedMarks] = React.useState(0)
  const [mediaPlayedJSON, setMediaPlayed] = React.useState({})
  const [batchExpired, setBatchExpired] = React.useState({})
  const [Name, setName] = React.useState("")
  const [PhoneNumber, setPhoneNumer] = React.useState("")
  const token = localStorage.getItem('teacher_token');
  const [Start, setStart] = React.useState(false);
  document.onkeydown = function (e) {
    if (e.key === 'F12') {
      return false;
    }
    if (e.ctrlKey && e.shiftKey && e.key === 'I') {
      return false;
    }
    if (e.ctrlKey && e.shiftKey && e.key === 'C') {
      return false;
    }
    if (e.ctrlKey && e.shiftKey && e.key === 'J') {
      return false;
    }
    if (e.ctrlKey && e.key === 'u') {
      return false;
    }
  }
  useEffect(() => {
    var mediaPlayed = {};
    const ArrayValue = Object.values(JSON.parse(ExamData.meta.exam_question_block_text))
    for (let i = 0; i < ArrayValue.length; i++) {
      const QuestionJSON = ArrayValue[i]
      mediaPlayed = {
        ...mediaPlayed,
        [`question-${i + 1}`]: "0",
        [`answer-${i + 1}-a`]: "0",
        [`answer-${i + 1}-b`]: "0",
        [`answer-${i + 1}-c`]: "0",
        [`answer-${i + 1}-d`]: "0",
      }
      setMediaPlayed(mediaPlayed)
      if (AnswerArray.length < ArrayValue.length)
        AnswerArray.push({
          question_number: QuestionJSON.question_number,
          correct_answer: QuestionJSON.correct_answer,
          answerChoosen: "",
          solved: 0
        })
    }
    const studentName = localStorage.getItem('studentName');
    const userPhoneNumber = localStorage.getItem('studentPhone');;
    if (studentName !== null)
      setName(studentName)
    if (userPhoneNumber !== null)
      setPhoneNumer(userPhoneNumber)
    downloadMedia()
  }, [])
  const SubmitExam = () => {
    setReload(true)
    const token = store.getState().LoginState.token
    const id = store.getState().LoginState.userID;
    var correct = 0;
    const date = new Date();
    const month = date.getMonth() < 9 ? `0${date.getMonth() + 1}` : `${date.getMonth() + 1}`
    const day = date.getDate() < 9 ? `0${date.getDate()}` : `${date.getDate()}`
    for (let i = 0; i < AnswerArray.length; i++) {
      if (AnswerArray[i].correct_answer == AnswerArray[i].answerChoosen)
        correct++
    }
    const data = {
      title: `Exam-${ExamData.title.rendered} User-${id} Date-${date.getUTCFullYear()}/${month}/${day}`,
      status: "publish",
      meta: {
        "exam_answers_array_results": JSON.stringify(AnswerArray),
        "exam_date_results": `${date.getUTCFullYear()}-${month}-${day}`,
        "exam_name_results": `${ExamData.title.rendered}`,
        "exam_id_results": `${ExamData.id}`,
        "exam_total_results": `${correct}`,
        "student_id_results": ``,
        "student_name_results": `${Name}`,
        "student_phone_number_results": `${PhoneNumber}`
      }
    }
    const teacherToken = localStorage.getItem('teacher_token');

    // AdsPOSTApiWithToken(data, slugs.db_slug_paid_results, teacherToken)
    //   .then((res) => {
    setReload(false)
    // setResultData(res.data)
    setChoose(4)
    // }).catch((err) => {
    //   console.log(err)
    //   console.log(err.response.data)
    // })
  }
  const downloadMedia = () => {
    const ArrayValue =
      // JSON.stringify(location).includes(slugs.start_demo_exam) ?
      //   Object.values(JSON.parse(ExamData.meta.exam_question_text)) :
      Object.values(JSON.parse(ExamData.meta.exam_question_block_text))
    const ArrayKeys =
      // JSON.stringify(location).includes(slugs.start_demo_exam) ?
      //   Object.keys(JSON.parse(ExamData.meta.exam_question_text)) :
      Object.keys(JSON.parse(ExamData.meta.exam_question_block_text))
    var QuestionDataCache = QuestionsData;
    var option1 = [];
    var option2 = [];
    var option3 = [];
    var option4 = [];
    var question = [];
    var question2 = [];
    var url1 = [];
    var url2 = [];
    var url3 = [];
    var url4 = [];
    var url5 = [];
    var url6 = [];

    for (let i = 0; i < ArrayValue.length; i++) {
      const QuestionJSON = ArrayValue[i]
      option1[i] = ArrayValue[i].option_1;
      option2[i] = ArrayValue[i].option_2;
      option3[i] = ArrayValue[i].option_3;
      option4[i] = ArrayValue[i].option_4;
      question[i] = ArrayValue[i].question_description;
      question2[i] = ArrayValue[i].question_media;

      url1[i] = ArrayValue[i].option_1
      url2[i] = ArrayValue[i].option_2
      url3[i] = ArrayValue[i].option_3
      url4[i] = ArrayValue[i].option_4
      url5[i] = ArrayValue[i].question_description
      url6[i] = ArrayValue[i].question_media

      if (ArrayValue[i].answer_media_type == "audio") {
        if (
          url1[i].includes("https://") &&
          url2[i].includes("https://") &&
          ArrayValue[i].option_3.includes("https://") &&
          ArrayValue[i].option_4.includes("https://")
        ) {
          axios({ method: "GET", url: `${nodejsurl}?url=${url1[i]}` })
            .then(res => {
              if (res.data.success)
                option1[i] = `data:audio/mpeg;base64,${res.data.data}`
              axios({ method: "GET", url: `${nodejsurl}?url=${url2[i]}` })
                .then(res => {
                  if (res.data.success)
                    option2[i] = `data:audio/mpeg;base64,${res.data.data}`
                  axios({ method: "GET", url: `${nodejsurl}?url=${url3[i]}` })
                    .then(res => {
                      if (res.data.success)
                        option3[i] = `data:audio/mpeg;base64,${res.data.data}`
                      axios({ method: "GET", url: `${nodejsurl}?url=${url4[i]}` })
                        .then(res => {
                          if (res.data.success)
                            option4[i] = `data:audio/mpeg;base64,${res.data.data}`
                          if (ArrayValue[i].question_description_type == "audio")
                            axios({ method: "GET", url: `${nodejsurl}?url=${url5[i]}` })
                              .then(res => {
                                if (res.data.success)
                                  question[i] = `data:audio/mpeg;base64,${res.data.data}`
                                QuestionDataCache = {
                                  ...QuestionDataCache,
                                  [ArrayKeys[i]]: {
                                    ...QuestionJSON,
                                    "question_description": question[i],
                                    "option_1": option1[i],
                                    "option_2": option2[i],
                                    "option_3": option3[i],
                                    "option_4": option4[i],
                                  }
                                }
                                setQuestionsData(QuestionDataCache)
                              }).catch(() => { })
                          if (ArrayValue[i].question_media_type == "audio")
                            axios({ method: "GET", url: `${nodejsurl}?url=${url5[i]}` })
                              .then(res => {
                                if (res.data.success)
                                  question[i] = `data:audio/mpeg;base64,${res.data.data}`
                                QuestionDataCache = {
                                  ...QuestionDataCache,
                                  [ArrayKeys[i]]: {
                                    ...QuestionJSON,
                                    "question_media": question[i],
                                    "option_1": option1[i],
                                    "option_2": option2[i],
                                    "option_3": option3[i],
                                    "option_4": option4[i],
                                  }
                                }
                                setQuestionsData(QuestionDataCache)
                              }).catch(() => { })
                        }).catch(() => { })


                    }).catch(() => { })

                }).catch(() => { })

            })
        }
      }
      else {
        if (ArrayValue[i].question_description_type == "audio")
          axios({ method: "GET", url: `${nodejsurl}?url=${url5[i]}` })
            .then(res => {
              if (res.data.success)
                question[i] = `data:audio/mpeg;base64,${res.data.data}`
              QuestionDataCache = {
                ...QuestionDataCache,
                [ArrayKeys[i]]: {
                  ...QuestionJSON,
                  "question_description": question[i],
                }
              }
              setQuestionsData(QuestionDataCache)
            }).catch(() => { })
        if (ArrayValue[i].question_media_type == "audio")
          axios({ method: "GET", url: `${nodejsurl}?url=${url6[i]}` })
            .then(res => {
              if (res.data.success)
                question2[i] = `data:audio/mpeg;base64,${res.data.data}`
              QuestionDataCache = {
                ...QuestionDataCache,
                [ArrayKeys[i]]: {
                  ...QuestionJSON,
                  "question_media": question2[i],
                }
              }
              setQuestionsData(QuestionDataCache)
            }).catch(() => { })
      }
      // if (i == ArrayValue.length - 1) { setTimeout(() => { setReload2(false) }, 5000) }
    }
  }

  return (
    <div style={{ padding: "0px 0 10px", position: "relative" }}>
      {!Start ?
        <div className='center'>
          <div style={{ padding: "15px" }}>
            <h2>{ExamData.title.rendered}</h2>
          </div>
          <img src='https://statics.teams.cdn.office.net/hashed/join-code-icon-4f716a8.svg'
            style={{ width: "100px", height: "100px" }}
          />
          <div style={{ fontSize: "14px", fontWeight: "bold" }}>User Details</div>
          <div className="row">
            <div className="col-lg-3 col-1" />

            <div className="col-lg-6 col-10 px-5">

              <div className="label-form">Student Name.</div>
              <input
                className="col-12  input-style"
                type="text"
                value={Name}
                onChange={(event) => { setName(event.target.value) }}
                placeholder="Enter Your Name"
                required
              /><br />
              <div className="label-form">Phone Number.</div>
              <input
                className="col-12  input-style"
                type={"text"}
                value={PhoneNumber}
                onChange={(event) => { setPhoneNumer(event.target.value) }}
                placeholder="Enter Phone Number"
                required
              /><br />
              <button onClick={() => {
                localStorage.setItem('studentName', Name);
                localStorage.setItem('studentPhone', PhoneNumber);
                setTimingStarted(true)

                setStart(true)
                setChoose(1)
              }} className="sign-in-button-1 col-8">
                Start Exam
              </button>
              <div style={{padding:"10px",fontSize:"18px"}}>
                Exam start गर्नु अगाडी headphone तल दिएको audio play गरी check गर्नु होला
                Audio को आवज नआए headphone को jack मिलाउनु होला
              </div>
              <audio
                controls
                src={`https://api.akbeducation.com/wp-content/uploads/2025/12/Sample-Audio.mp3`}
              >
              </audio>
              <br />
            </div>
          </div>
        </div>
        :
        <div style={{ userSelect: "none" }}>
          <div style={{ position: "relative" }}>

            {choose == 0 &&
              <div style={{ display: 'flex', justifyContent: 'center', padding: "30px" }}>
                <div style={{ width: "100%" }}>
                  <div style={{ textAlign: 'center' }}>
                    <h1>{ExamData.title.rendered}</h1>
                    <br />
                    {LoginUser.userPhoto === undefined ?
                      <img src={UserPlaceHolder}
                        height="30px"
                      />
                      :
                      <img src={`${LoginUser.userPhoto}`} className={"height-width-150 border border-dark"} />
                    }
                  </div>
                  <div>
                    <br />
                    <b>Name of Student: {LoginUser.userName}</b>
                    <br />
                    <b>Student Email: {LoginUser.userEmail}</b>
                    <br />
                  </div>
                  <div>
                    <b>Exam description</b>
                    <br />
                    <div dangerouslySetInnerHTML={{ __html: ExamData.meta.exam_details }} />
                    {/* {ExamData.content.rendered} */}
                  </div>
                  <br />
                  <div className="row">
                    <div className="col-lg-4 col-12" />
                    <div className="col-lg-4 col-12 center">
                      <button className="sign-in-button-11 col-lg-8 col-7"
                        onClick={() => {
                          setChoose(1)
                          setTimingStarted(true)
                        }}
                      >
                        Get Started
                      </button>
                      <button className="sign-in-button-4 col-lg-6 col-6"
                        onClick={() => {
                          history.goBack()
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            }

            {choose == 1 &&
              <div
                className='question-view-main'
              >
                <div className='question-width'>
                  <SecondScreenComponent
                    QuestionsEditKey={QuestionsEditKey} setQuestionsEditKey={setQuestionsEditKey}
                    QuestionsEditData={QuestionsEditData} setQuestionsEditData={setQuestionsEditData}
                    QuestionsData={QuestionsData} setQuestionsData={setQuestionsData}
                    QuestionsEditMode={QuestionsEditMode} setQuestionsEditMode={setQuestionsEditMode}
                    TimingStarted={TimingStarted} setTimingStarted={setTimingStarted}
                    ExamData={ExamData}
                    AnswerArray={AnswerArray}
                    setChoose={setChoose}
                    SubmitExam={SubmitExam}
                    mediaPlayedJSON={mediaPlayedJSON}
                    PlaySingle={PlaySingle}
                  />
                </div>
              </div>
            }
            {choose == 2 &&
              <div>
                <FinalScreenExam
                  ExamData={ExamData}
                  QuestionsData={QuestionsData}
                  AnswerArray={AnswerArray}
                  userDetails={userDetails}
                  ResultData={ResultData}
                />
              </div>
            }
            {choose == 4 &&
              <div>
                <ColorVision
                  setChoose1={setChoose}
                />
              </div>

            }
          </div>

        </div>
      }
    </div>
  )
}
